<template>
    <div>
        <el-alert
            :closable="false"
            class="mb-2"
            :title="$t.__('developerPage.WebhooksForms.Webhooks.WebhookSlack.add_webhook_error')"
            type="success"
        >
        </el-alert>
        <div class="prelative mt-4" v-if="loading">
            <preloader :background="false" :display="loading" />
        </div>
        <webhooks-form-template :logs="logs" :form="form" :rules="rules" @submit="submit" v-else>
            <template slot="endpoint">
                <el-form-item prop="endpoint" :error="errors.endpoint">
                    <span class="gray-100" slot="label">
                        {{ $l10n.__('Endpoint Slack') }}
                    </span>
                    <div class="flex-row ai-center">
                        <i class="icon-link mr-2"></i>
                        <el-input v-model="form.endpoint"></el-input>
                    </div>
                </el-form-item>
                <el-form-item class="mb-0" prop="default_channel" :error="errors.default_channel">
                    <span class="gray-100" slot="label">
                        {{ $l10n.__('Channel Slack par défaut') }}
                    </span>
                    <div class="flex-row ai-center">
                        <i class="fa fa-15 fa-slack mr-2"></i>
                        <el-input v-model="form.default_channel" class="wp-5"></el-input>
                    </div>
                </el-form-item>
                <div>
                    <el-checkbox v-model="form.is_enabled">{{
                        $l10n.__('Webhook actif ?')
                    }}</el-checkbox>
                </div>
            </template>
            <p slot="configDescription" class="mt-2 mb-4">
                {{
                    $l10n.__('Vous pouvez personnaliser pour chaque notification le channel Slack.')
                }}
            </p>
            <template slot="tagEvents" slot-scope="scopeEvents">
                {{ activeEvents(scopeEvents.currentLog.id) }} /
                {{ getAllEventsForParentLog(scopeEvents.currentLog.id).length }}
            </template>
            <!-- Logs events -->
            <div slot="events" slot-scope="scope">
                <el-table :data="getEventsConfigByLog(scope.log.id)" class="b-1" stripe>
                    <el-table-column prop="label" width="390">
                        <span slot="header" slot-scope="scopeHeader" class="regular">
                            {{ getTableTitleByLog(scope.log) }}
                        </span>
                    </el-table-column>
                    <el-table-column label="Channel">
                        <div slot-scope="scope" class="flex-level">
                            <i class="fa fa-15 fa-slack mr-2"></i>
                            <el-input v-model="scope.row.channel"></el-input>
                        </div>
                    </el-table-column>
                    <el-table-column
                        :label="$t.__('developerPage.WebhooksForms.Webhooks.activated')"
                        width="65"
                    >
                        <el-switch
                            slot-scope="scopeEnabled"
                            @input="(e) => handleSwitch(e, scopeEnabled.row)"
                            :value="scopeEnabled.row.is_enabled"
                        ></el-switch>
                    </el-table-column>
                </el-table>

                <!-- Child events to main Log -->
                <div v-for="childLog of getLogsChildByLog(scope.log.id)" :key="childLog.id">
                    <el-table :data="getEventsConfigByLog(childLog.id)" class="b-1" stripe>
                        <el-table-column prop="label" width="390">
                            <span slot="header" slot-scope="scopeHeader" class="regular">
                                {{ getTableTitleByLog(childLog) }}
                            </span>
                        </el-table-column>
                        <el-table-column label="Channel">
                            <div slot-scope="scope" class="flex-level">
                                <i class="fa fa-15 fa-slack mr-2"></i>
                                <el-input v-model="scope.row.channel"></el-input>
                            </div>
                        </el-table-column>
                        <el-table-column
                            :label="$t.__('developerPage.WebhooksForms.Webhooks.activated')"
                            width="65"
                        >
                            <el-switch
                                slot-scope="scopeEnabled"
                                @input="(e) => handleSwitch(e, scopeEnabled.row)"
                                :value="scopeEnabled.row.is_enabled"
                            ></el-switch>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </webhooks-form-template>
    </div>
</template>
<script>
import WebhooksFormTemplate from 'vcomponents/developerPage/WebhooksForms/WebhooksFormTemplate.vue';
import WebhooksMixins from 'vcomponents/developerPage/WebhooksForms/WebhooksMixins';
export default {
    mixins: [WebhooksMixins],
    components: {
        WebhooksFormTemplate,
    },
    created() {
        delete this.form.object_in_payload;
        delete this.form.json_content_type;
        delete this.form.sign_key;
        this.form = {
            ...this.form,
            default_channel: '',
        };

        this.rules.endpoint[0] = {
            ...this.rules.endpoint[0],
            pattern: /^https?:\/\/hooks.slack.com\/services\/T[\S]{8,}\/B[\S]{8,}\/[\S]{24}$/,
            message: this.$l10n.__('Veuillez renseigner un endpoint Slack valide'),
        };
        this.rules.default_channel = [
            {
                required: true,
                type: 'string',
                message: this.$l10n.__('Veuillez renseigner un Channel Slack par défaut valide'),
            },
        ];
    },
};
</script>
